import type { BlendArrayModifier } from "../blend-reader/types/BlendModifier.ts";
import { MODIFIER_DEFAULTS } from "../blend-reader/types/BlendModifier.ts";
import { clampArrayModifierCount } from "./modifierLimits.ts";

export type SurfaceArrayParams = Readonly<Record<string, unknown>>;

/**
 * Build the Array modifier driven by surface/object-create Count + Offset
 * controls. Returns null for Count < 2 so callers can clear their owned block.
 */
export function buildSurfaceArrayModifier(
  params: SurfaceArrayParams,
): BlendArrayModifier | null {
  const count = clampArrayModifierCount(Number(params.count ?? 1));
  if (count < 2) return null;
  return {
    ...(MODIFIER_DEFAULTS.array() as BlendArrayModifier),
    count,
    relativeOffset: [
      Number(params.offsetX ?? 1),
      Number(params.offsetY ?? 0),
      Number(params.offsetZ ?? 0),
    ],
    useRelativeOffset: true,
    useConstantOffset: false,
  };
}
